export default import.meta.ROLLDOWN_FILE_URL_hJ1OfxpGBPbIkJSwAe8AEQ